export const MeetLocationType = "integrations:google:meet";

export const MSTeamsLocationType = "integrations:office365_video";
